<mat-card
    [ngStyle]="setCardHeight()"
    class="large-card"
    [ngClass]="{ 'lg-scrollbar': useLGScroll, 'double-large-cards': !showTitle }"
>
    <card-controller-panel
            [cardInfo]="cardControllerInfo"
    ></card-controller-panel>
    <div
        *ngIf="showChartCustomTitle && hasData && isDataReady && showTitle"
        class="chart-title-container"
    >
        <div class="row-layout-track title-content">
            <div class="dashboard-plot-inline-text-left layout-flex-1">
                <label
                    (click)="clickTitleValue()"
                    [ngStyle]="{ cursor: hasDrilldownAcess ? 'pointer' : '' }"
                >
                    {{ chartTitleData.chartTile }}
                </label>
            </div>
            <div
                class="dashboard-plot-inline-text-right largecard-layout-box__65pct"
                [ngStyle]="{ color: chartTitleData.chartLabelColor }"
                *ngIf="
                    showDashboardTextRight &&
                    !chartTitleData.showMainValueToRight &&
                    !chartTitleData.isDonut
                "
            >
                <span style="display: inline-block" [innerHTML]="chartTitleData.svgIcon"></span>
                &ensp;<span [ngStyle]="comparisonStyle">
                    {{ chartTitleData.chartComparisonValue }}
                </span>
            </div>
            <div
                class="dashboard-plot-inline-text-right largecard-layout-box__35pct"
                *ngIf="
                    showMainValue &&
                    !showDashboardTextRight &&
                    chartTitleData.showMainValueToRight &&
                    !chartTitleData.isDonut
                "
            >
                <div>
                    <label
                        class="dashboard-plot-main-value"
                        (click)="clickTitleValue()"
                        [ngStyle]="{ cursor: hasDrilldownAcess ? 'pointer' : '' }"
                    >
                        {{ chartTitleData.chartMainValue }}
                    </label>
                    <label *ngIf="chartTitleData.isMainValueUnitVisible">{{
                        chartTitleData.mainValueUnit
                    }}</label>
                </div>
                <!--    TODO: Replace repetition code with ngTemplate ex: code for description-text-->
                <div
                    *ngIf="
                        chartTitleData.showDescriptionText && chartTitleData.showMainValueToRight
                    "
                    class="card-description-text"
                >
                    {{ chartTitleData.descriptionText }}
                </div>
            </div>
        </div>
        <div
            *ngIf="showMainValue && !chartTitleData.showMainValueToRight"
            class="chart-main-value-area"
            [ngStyle]="{ 'text-align': chartTitleData.mainValueAlignTo }"
        >
            <label
                class="dashboard-plot-main-value"
                (click)="clickTitleValue()"
                [ngStyle]="{ cursor: hasDrilldownAcess ? 'pointer' : '' }"
            >
                {{ chartTitleData.chartMainValue
                }}{{
                    chartTitleData.chartSecondaryValue
                        ? ' | ' + chartTitleData.chartSecondaryValue
                        : ''
                }}
            </label>
            <label *ngIf="chartTitleData.isMainValueUnitVisible">{{
                chartTitleData.mainValueUnit
            }}</label
            ><br />
            <label
                class="dashboard-plot-toggle-value"
                [ngStyle]="{ display: chartTitleData.isChartSubValueVisible }"
            >
                {{ chartTitleData.chartSubItemValue }}
            </label>
        </div>
        <!--    TODO: Replace repetition code with ngTemplate ex: code for description-text-->
        <div
            *ngIf="chartTitleData.showDescriptionText && !chartTitleData.showMainValueToRight"
            class="card-description-text"
        >
            {{ chartTitleData.descriptionText }}
        </div>
    </div>
    <div id="{{ chartId }}" [ngStyle]="{ display: hasData ? '' : 'none' }"></div>
    <div *ngIf="!isDataReady" class="large-card-spinner-area">
        <spin-loader [type]="'spinner'"></spin-loader>
    </div>
    <div class="no-data-message-area" *ngIf="!hasData && isDataReady">
        <no-data-screen [noDataType]="noDataType"> </no-data-screen>
    </div>
</mat-card>
